import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import config from "../coreFIles/config";
import { CiCircleList } from "react-icons/ci";
import { CiMail } from "react-icons/ci";

const Sidebar = () => {
  const location = useLocation();

  const [openCMS, setOpenCMS] = useState(false);

  // ✅ CMS Routes List
  const cmsRoutes = [
    "privacyPolicy",
    "termsCondition",
    "tokenRisks",
    "governingLaw",
    "amlKycPolicy",
    "faqList",
    "vestingSchedule"
  ];

  // ✅ Check if current route is CMS route
  const isCMSRoute = cmsRoutes.some((route) =>
    location.pathname.includes(route)
  );

  // ✅ Auto open CMS dropdown when on CMS page
  useEffect(() => {
    setOpenCMS(isCMSRoute);
  }, [location.pathname]);

  const logout = () => {
    Cookies.remove("OnchainMatrix");
    window.location.href = `${config.baseUrl}`;
  };

  const toggleCMS = () => {
    setOpenCMS((prev) => !prev);
  };

  return (
    <aside className="main-sidebar hide-scrollbar">
      <section className="sidebar position-relative">
        <div className="multinav">
          <div className="multinav-scroll pt-15" style={{ height: "100%" }}>
            <ul className="sidebar-menu" data-widget="tree">




              <li className={location.pathname === `${config.baseUrl}contact-us` ? "active" : ""}>
                <Link to={`${config.baseUrl}contact-us`}>
                  <i className="fa fa-comment" />
                  <span>Contact Us Management</span>
                </Link>
              </li>
              <li className={location.pathname === `${config.baseUrl}seed-round` ? "active" : ""}>
                <Link to={`${config.baseUrl}seed-round`}>
                  <i className="fa fa-sitemap" />
                  <span>Seed Round Process</span>
                </Link>
              </li>




              <li className={location.pathname === `${config.baseUrl}changepassword` ? "active" : ""}>
                <Link to={`${config.baseUrl}changepassword`}>
                  <i className="fa fa-lock" />
                  <span>Change Password</span>
                </Link>
              </li>

              {/* Logout */}

              {/* Profile
              <li className={location.pathname === `${config.baseUrl}profile` ? "active" : ""}>
                <Link to={`${config.baseUrl}profile`}>
                  <i className="fa fa-user-circle" />
                  <span>Profile</span>
                </Link>
              </li> */}

              {/* ================= CMS MANAGEMENT =================
              <li className={isCMSRoute ? "active" : ""}>
                <a href="javascript:void(0)" onClick={toggleCMS}>
                  <i className="fa fa-file-text" />
                  <span className="me-2">CMS Management</span>
                  <i className={openCMS ? "fa fa-angle-up" : "fa fa-angle-down"} />
                </a>

                {openCMS && (
                  <ul className="ms-4">

                    {cmsRoutes.map((route) => {
                      const routePath = `${config.baseUrl}${route}`;
                      const labelMap = {
                        privacyPolicy: "Privacy Policy",
                        termsCondition: "Terms & Condition",
                        tokenRisks: "Token Risks",
                        governingLaw: "Governing Law",
                        amlKycPolicy: "AML/KYC Policy",
                        faqList: "FAQ List",
                        vestingSchedule: "Vesting Schedule"
                      };

                      return (
                        <li
                          key={route}
                          className={
                            location.pathname === routePath
                              ? "active d-flex align-items-center"
                              : "d-flex align-items-center"
                          }
                        >
                          <Link to={routePath} style={{ width: "100%" }}>
                            <CiCircleList
                              style={{
                                width: 18,
                                height: 18,
                                marginRight: 6,
                              }}
                            />
                            {labelMap[route]}
                          </Link>
                        </li>
                      );
                    })}

                  </ul>
                )}
              </li> */}

              {/* Logout */}
              <li>
                <Link onClick={logout}>
                  <i className="fa fa-sign-out" />
                  <span>Logout</span>
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </section>
    </aside>
  );
};

export default Sidebar;
